import { ContactFormBase } from './ContactFormBase';

export type { TypeContactFormBaseProps } from './types';
export default ContactFormBase;
